import React from "react"
import { useNavigate } from "react-router-dom"
import "../../styles/Components/pageheader.css"
import { useState, useEffect, useRef } from "react"
import { useSelector } from "react-redux"
import { message } from "antd"
import { getUserCookies } from "../../utils/Cookies"
import { jwtDecode } from "jwt-decode"
import { translations } from "../../utils/Translation/staticTranslation"
import { effectiveHighestRole } from "../../utils/modulePermissionSidebar"
import { getLocalizedPath } from "../../utils/authLanguageRoutes"
import { getAppLanguage } from "../../utils/getAppLanguage"

const PageHeader = ({
  title,
  buttonText,
  buttonPath,
  onClick,
  dropdownItems,
  selectedStore,
  showDrawer,
  storeSelectionText,
  onAddImages,
  addImagesDisabled = false,
  addImagesDisabledTitle,
  buttonDisabled = false,
  buttonDisabledTitle,
  /** Show primary action without JWT highest_role (e.g. organization plan owner). */
  forceShowButton = false,
}) => {
  const navigate = useNavigate()
  const user = useSelector((state) => state.user.user)
  const token = getUserCookies()?.token
  const decoded = token ? jwtDecode(token) : null
  const jwtHighest = decoded?.highest_role
  const effectiveHighest = effectiveHighestRole(user, jwtHighest)

  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const lang = getAppLanguage()
  const productPage = translations[lang]?.productPage

  const navigateLocalized = (path) => {
    if (!path) return
    navigate(getLocalizedPath(path, lang))
  }

  const isSuperAdmin =
    typeof effectiveHighest === "string" &&
    effectiveHighest.toUpperCase() === "SUPERADMIN"

  const isLibraryTitle =
    (typeof title === "string" && title.trim().toLowerCase() === "library") ||
    (typeof title === "string" && title.trim().toLowerCase() === "المكتبة")

  return (
    <div className="d-flex justify-content-between align-items-center mb-18 position-relative">
      <h1 className="text-141414 text-20">{title}</h1>

      <div className="d-flex align-items-center">
        {/* Add Images button – only for SUPERADMIN on "Library" */}
        {isSuperAdmin && isLibraryTitle && (
          <button
            type="button"
            className={`add-store ${lang === "ar" ? "mr-10" : "ml-10"}`}
            disabled={addImagesDisabled}
            title={addImagesDisabled ? addImagesDisabledTitle : undefined}
            onClick={() => {
              if (addImagesDisabled) return
              if (typeof onAddImages === "function") {
                onAddImages()
              } else {
                onAddImages()
              }
            }}
          >
            <img src="/icons/addicon.svg" alt="" className="mr-6" />
            {productPage?.add_images || lang === "ar"
              ? "إضافة صور"
              : "Add Images"}
          </button>
        )}

        {/* Existing Add Button with Dropdown (unchanged) */}
        {forceShowButton ||
        effectiveHighest === "OWNER" ||
        effectiveHighest === "ADMIN" ||
        effectiveHighest === "SUPERADMIN" ? (
          buttonText && (
            <div className="relative" ref={dropdownRef}>
              <button
                className="add-store"
                type="button"
                disabled={buttonDisabled}
                title={buttonDisabled ? buttonDisabledTitle : undefined}
                onClick={() => {
                  if (buttonDisabled) return
                  buttonPath && navigateLocalized(buttonPath)
                  onClick && onClick()
                  setIsOpen(!isOpen)
                }}
              >
                {(forceShowButton || effectiveHighest !== "SUPERADMIN") && (
                  <img src="/icons/addicon.svg" alt="" className="mr-6" />
                )}{" "}
                {buttonText}
                {!forceShowButton && effectiveHighest === "SUPERADMIN" && (
                  <img
                    style={{
                      transform: lang === "ar" ? "rotateY(180deg)" : "none",
                    }}
                    src="/icons/arrowSelection.svg"
                    alt=""
                    className={`${lang === "ar" ? "mr-10" : "ml-10"}`}
                  />
                )}
              </button>

              {isOpen && dropdownItems?.length > 0 && (
                <div className="absolute dropdown-menu-product">
                  {dropdownItems.map((item, index) => (
                    <div
                      key={index}
                      className="dropdown-item-product"
                      onClick={() => {
                        if (item.path && !selectedStore) {
                          setIsOpen(false)
                          message.error(productPage?.store_select_error)
                          return
                        }
                        if (item.onClick) {
                          item.onClick()
                        } else if (item.path) {
                          navigateLocalized(item.path)
                        }
                        setIsOpen(false)
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        ) : (
          <></>
        )}

        {showDrawer && (
          <button
            className={`${
              lang === "ar" ? "mr-10" : "ml-10"
            } ml-10 pxy-13-26 store-selection-product-page mr-3 pointer text-16 font-500 text-center`}
            onClick={showDrawer}
          >
            {selectedStore?.store_name || storeSelectionText}{" "}
            <img
              style={{ transform: lang === "ar" ? "rotateY(180deg)" : "none" }}
              className={`${lang === "ar" ? "mr-10" : "ml-10"}`}
              src="/icons/arrowSelectionDark.svg"
              alt=""
            />
          </button>
        )}
      </div>
    </div>
  )
}

export default PageHeader
